<div id="content" class="without-subnavbar allcp-form" ng-controller="SettingController" ng-init="getWorkSteps()">
    <div ng-include="'modules/company/menus/setting_menu.html'"></div>
    <div class="panel-body">

        <h5>Order Statuses</h5>
        <hr>
        <div class="panel-body mn pn">

            <div ui-sortable="sortableOptions" ng-model="data.steps">
            <!-- <div> -->
                <div class="row m10" ng-repeat="item in data.steps">
                    <div class="col-md-9 work-steps">
                        <!--
                        <a href="#" class="mr10 ml10">
                            <i class="fa fa-bars"></i>
                        </a>
                        -->
                        <strong ng-style="{'color': item.color }">{{ item.name }}</strong>
                        <!-- <strong class="ml10" ng-style="{'color': item.color }">{{ item.mobile_name }}</strong> -->
                        <div class="desc" ng-if="item.sms_send == 1">
                            <strong>SMS CONTENT : </strong>
                            <p>{{ item.sms.content }}</p>
                        </div>
                        <div class="desc" ng-if="item.mail_send == 1">
                            <strong>MAIL CONTENT : </strong>
                            <p><span ng-bind-html="item.mail.content"></span></p>
                        </div>
                    </div>

                    <div class="col-md-12 mt10">
                        <a href="#" style="color:#8da2b3;margin-right:10px;" ng-click="editStep(item)"> Edit </a>
                        <!-- <a href="#" style="color:#8da2b3" ng-click="deleteStep(item.id,'set')"> Sil</a> -->
                    </div>
                </div>

                <div class="row m10" ng-repeat="item in data.fixed_steps">
                    <div class="col-md-9 work-steps">
                        <strong ng-style="{'color': item.color }">{{ item.name }}</strong>
                        <div class="desc" ng-if="item.sms_send == 1">
                            <strong>SMS CONTENT : </strong>
                            <p>{{ item.sms.content }}</p>
                        </div>
                        <div class="desc" ng-if="item.mail_send == 1">
                            <strong>MAIL CONTENT : </strong>
                            <p><span ng-bind-html="item.mail.content"></span></p>
                        </div>
                    </div>

                    <div class="col-md-12 mt10">
                        <a href="#" style="color:#8da2b3;margin-right:10px;" ng-click="editStep(item)"> Edit </a>
                    </div>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-md-9 pr10">
                    <a href="#" ng-click="newStep()" class="btn btn-success btn-block">
                        <i class="fa fa-plus"></i> New Step
                    </a>
                </div>
            </div> -->
        </div>

        <div class="modal right fade" id="newStep" tabindex="-1" role="dialog" aria-labelledby="newStepLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">
                            <h4 ng-if="step.id">Edit</h4>
                            <h4 ng-if="!step.id">New</h4>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="icon-close-circle"></i>
                        </button>
                    </div>

                    <div class="modal-body order-detail-page">
                        <div class="modal-body-container">
                            <div class="tab-content">
                                <div class="tab-pane active">
                                    <form ng-submit="saveStep()" class="form-horizontal allcp-form">

                                        <div class="form-group floating">
                                            <input type="text" ng-model="step.name" class="form-control input-md" placeholder="Name" required>
                                            <label>Name</label>
                                        </div>

                                        <!-- <div class="form-group floating">
                                            <input type="text" ng-model="step.mobile_name" class="form-control input-md" placeholder="Mobile Name" required>
                                            <label>Mobile Name</label>
                                        </div> -->

                                        <div class="form-group floating" ng-init="step.color = colorList[0]">
                                            <label>Color</label>
                                            <ul class="color-palette" >
                                                <li 
                                                    ng-repeat="color in colorList"
                                                    ng-style="{'background-color': color }"
                                                    class="color-selected" 
                                                    ng-click="step.color = color" 
                                                    ng-class="step.color == color ? 'selected' : ''">
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="form-group floating">
                                            <label>Send Sms</label>
                                            <div class="radio-custom radio-info mb15">
                                                <input type="radio" name="types" id="sms_send" ng-model="step.sms_send" value="1" ng-checked="true">
                                                <label for="sms_send" class="pt5">Yes</label>
                                                <input type="radio" name="types" id="not_send" ng-model="step.sms_send" value="0">
                                                <label for="not_send" class="pt5">No</label>
                                            </div>
                                        </div>

                                        <div class="form-group floating" ng-if="step.sms_send == 1">
                                            <label>Sms Content</label>
                                            <div class="dropdown mb10">
                                                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown">Add Variable
                                                <span class="caret"></span></button>
                                                <ul class="dropdown-menu">
                                                    <li><a href="#" ng-click="addAttr('[Order ID]',step.sms)" class="fs13 text-primary underline">[Order ID]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Delivery Customer Name]',step.sms)" class="fs13 text-primary underline">[Delivery Customer Name]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Worker Name]',step.sms)" class="fs13 text-primary underline">[Worker Name]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Customer Phone Number]',step.sms)" class="fs13 text-primary underline">[Customer Phone Number]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Customer Service Phone Number]',step.sms)" class="fs13 text-primary underline">[Customer Service Phone Number]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Customer Name]',step.sms)" class="fs13 text-primary underline">[Customer Name]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Doing Business As]',step.sms)" class="fs13 text-primary underline">[Doing Business As]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Delivery Date]',step.sms)" class="fs13 text-primary underline">[Delivery Date]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Order Link]',step.sms)" class="fs13 text-primary underline">[Order Link]</a></li>
                                                </ul>
                                            </div>
                                            <textarea class="form-control input-md" style="height:100px;" ng-model="step.sms.content" rows="15" cols="15" required></textarea>
                                            <span class="help-block">
                                                {{ step.sms.content.length }} Length
                                            </span>
                                        </div>

                                        <div class="form-group floating">
                                            <label>Send Mail</label>
                                            <div class="radio-custom radio-info mb15">
                                                <input type="radio" name="mail_send" id="mail_send" ng-model="step.mail_send" value="1" ng-checked="true">
                                                <label for="mail_send" class="pt5">Yes</label>
                                                <input type="radio" name="mail_send" id="mail_not_send" ng-model="step.mail_send" value="0">
                                                <label for="mail_not_send" class="pt5">No</label>
                                            </div>
                                        </div>

                                        <div class="form-group floating" ng-if="step.mail_send == 1">
                                            <label>Mail Title</label>
                                            <div class="dropdown mb10">
                                                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown">Add Variable
                                                <span class="caret"></span></button>
                                                <ul class="dropdown-menu">
                                                    <li><a href="#" ng-click="addAttrTitle('[Order ID]',step.mail)" class="fs13 text-primary underline">[Order ID]</a></li>
                                                    <li><a href="#" ng-click="addAttrTitle('[Delivery Customer Name]',step.mail)" class="fs13 text-primary underline">[Delivery Customer Name]</a></li>
                                                    <li><a href="#" ng-click="addAttrTitle('[Worker Name]',step.mail)" class="fs13 text-primary underline">[Worker Name]</a></li>
                                                    <li><a href="#" ng-click="addAttrTitle('[Customer Phone Number]',step.mail)" class="fs13 text-primary underline">[Customer Phone Number]</a></li>
                                                    <li><a href="#" ng-click="addAttrTitle('[Customer Service Phone Number]',step.mail)" class="fs13 text-primary underline">[Customer Service Phone Number]</a></li>
                                                    <li><a href="#" ng-click="addAttrTitle('[Customer Name]',step.mail)" class="fs13 text-primary underline">[Customer Name]</a></li>
                                                    <li><a href="#" ng-click="addAttrTitle('[Doing Business As]',step.mail)" class="fs13 text-primary underline">[Doing Business As]</a></li>
                                                    <li><a href="#" ng-click="addAttrTitle('[Delivery Date]',step.mail)" class="fs13 text-primary underline">[Delivery Date]</a></li>
                                                    <li><a href="#" ng-click="addAttrTitle('[Order Link]',step.mail)" class="fs13 text-primary underline">[Order Link]</a></li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="form-group floating" ng-if="step.mail_send == 1">
                                            <input type="text" ng-value="step.mail.title" class="form-control input-md"  placeholder="Mail Title">
                                            <label>Mail Title</label>
                                        </div>

                                        <div class="form-group floating" ng-if="step.mail_send == 1">
                                            <label>Mail Content</label>
                                            <div class="dropdown mb10">
                                                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown">Add Variable
                                                <span class="caret"></span></button>
                                                <ul class="dropdown-menu">
                                                    <li><a href="#" ng-click="addAttr('[Order ID]',step.mail)" class="fs13 text-primary underline">[Order ID]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Delivery Customer Name]',step.mail)" class="fs13 text-primary underline">[Delivery Customer Name]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Worker Name]',step.mail)" class="fs13 text-primary underline">[Worker Name]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Customer Phone Number]',step.mail)" class="fs13 text-primary underline">[Customer Phone Number]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Customer Service Phone Number]',step.mail)" class="fs13 text-primary underline">[Customer Service Phone Number]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Customer Name]',step.mail)" class="fs13 text-primary underline">[Customer Name]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Doing Business As]',step.mail)" class="fs13 text-primary underline">[Doing Business As]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Delivery Date]',step.mail)" class="fs13 text-primary underline">[Delivery Date]</a></li>
                                                    <li><a href="#" ng-click="addAttr('[Order Link]',step.mail)" class="fs13 text-primary underline">[Order Link]</a></li>
                                                </ul>
                                            </div>
                                            <text-angular 
                                                ta-toolbar="textOptions"
                                                ng-model="step.mail.content">
                                            </text-angular>
                                        </div>

                                        <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                                        <button type="submit" class="btn btn-primary" ng-if="!step.id">Add</button>
                                        <button type="submit" class="btn btn-warning" ng-if="step.id">Update</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 

        <div class="modal fade" id="delete" tabindex="-1" role="dialog" aria-labelledby="deleteLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h5 class="modal-title"> <strong> Dikkat!</strong></h5>
                </div>
                <div class="modal-body">
                    <strong class="text-danger">
                        <i class="fa fa-exclamation-triangle"></i> Yapacağınız silme işlemi geri alınamaz bir işlemdir.
                    </strong>
                    <p><strong>Silmek istediğinizden emin misiniz ? </strong> </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
                    <button type="button" class="btn btn-danger" ng-click="deleteStep('','delete')" data-dismiss="modal">Sil</button>
                </div>
                </div>
            </div>
        </div>

    </div>
</div>
